import type { ChangelogEntry } from "../types";

/**
 * Et prosjekt kunne bare faktureres til prosjektets kunde. Nå kan en enkelt
 * faktura gå til en annen kunde, for eksempel en partner som betaler en del.
 */
export const KUNDE_PER_FAKTURA_2026_10: ChangelogEntry = {
  id: "2026-10-29-kunde-per-faktura",
  date: "2026-10-29",
  title: "Fakturer en annen kunde på samme prosjekt",
  summary: "Fakturaskjemaet har fått «Bytt kunde», så en faktura kan gå til en annen kunde enn prosjektets.",
  sections: [
    {
      heading: "Fakturering",
      minRole: "user",
      items: [
        {
          title: "«Bytt kunde» i fakturaskjemaet",
          kind: "nytt",
          body: "Fakturaen går til prosjektets kunde som før, men du kan velge en annen kunde for akkurat denne fakturaen. Kunder som er fakturert før på prosjektet ligger øverst, og du kan søke i alle kunder eller lage en ny. Referanser og faktura-e-post hentes fra den valgte kundens kundekort.",
        },
        {
          title: "Kunde i fakturalista og på kundekortet",
          kind: "nytt",
          body: "Fakturalista på prosjektet viser hvilken kunde hver faktura gikk til, med merket «annen kunde» når det ikke er prosjektets kunde. Fakturaen vises på kundekortet til kunden som ble fakturert, og teller fortsatt i «Fakturert hittil» på prosjektet.",
        },
      ],
    },
  ],
};
